import Moment from 'moment';
import constants from '../constants';

export function evaluateTCPA(fields) {

    const OPTED_IN_OPTION = 0;
    const OPTED_OUT_OPTION = 1;

    let isTCPA = OPTED_OUT_OPTION;

    let isOptInDateExisting = false;
    let isOptOutDateExisting = false;

    if (Moment(fields.optedInDate, 'YYYY-MM-DD', true).isValid()) {
        isOptInDateExisting = true;
    }

    if (Moment(fields.optedOutDate, 'YYYY-MM-DD', true).isValid()) {
        isOptOutDateExisting = true;
    }

    if (!isOptInDateExisting && !isOptOutDateExisting) {
        let agreementVal = fields.agreement.toLowerCase();
        if (constants.affirmatives.includes(agreementVal)) {
            isTCPA = OPTED_IN_OPTION;
        }
    } else {
        if (isOptInDateExisting && isOptOutDateExisting) {

            let inDate = Moment(fields.optedInDate, 'YYYY-MM-DD');
            let outDate = Moment(fields.optedOutDate, 'YYYY-MM-DD');

            if (inDate.isAfter(outDate)) {
                isTCPA = OPTED_IN_OPTION;
            }

        } else {
            if (isOptInDateExisting) {
                isTCPA = OPTED_IN_OPTION;
            }
        }
    }

    return isTCPA;
}

